import { withAuthenticator } from 'aws-amplify-react';

export const authHOC = (component) => {
  return withAuthenticator(component, false, [], null, null, {
    hideSignUp: true,
  });
}
